(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cw-hero-split"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.cwh').forEach(function (root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var tabs = root.querySelectorAll('[data-cwh-tab]');
    if (!tabs.length) return;
    var imgs = root.querySelectorAll('[data-cwh-img]');
    var cap = root.querySelector('[data-cwh-cap]');
    var caps = [];
    root.querySelectorAll('[data-cwh-tab]').forEach(function (t) { caps.push(t.dataset.cap || ''); });
    function show(i) {
      tabs.forEach(function (t, n) { t.setAttribute('aria-selected', String(n === i)); });
      imgs.forEach(function (im, n) { im.classList.toggle('is-on', n === i); });
      if (cap && caps[i]) cap.textContent = caps[i];
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var n = (i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
        tabs[n].focus(); show(n);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-tool-age"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cwt="age"]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var $ = function (s) { return root.querySelector(s); };
  // Veterinary guideline chart (AVMA/AKC): 15 at year one, +9 for year two, then +4/+5/+6/+7 per year by size.
  var PER_YEAR = { small: 4, medium: 5, large: 6, giant: 7 };
  var SENIOR = { small: 10, medium: 8, large: 7, giant: 6 };
  var LIFE = { small: '12–16', medium: '10–13', large: '9–12', giant: '7–10' };
  var state = { years: 4, months: 0, size: 'medium' };
  function human(age, size) {
    if (age <= 0) return 0;
    if (age <= 1) return 15 * age;
    if (age <= 2) return 15 + 9 * (age - 1);
    return 24 + PER_YEAR[size] * (age - 2);
  }
  function stage(age, size) {
    if (age < 1) return 'Puppy';
    if (age < SENIOR[size] * 0.6) return 'Adult';
    if (age < SENIOR[size]) return 'Mature adult';
    return 'Senior';
  }
  function compute() {
    var age = state.years + state.months / 12, size = state.size;
    var h = human(age, size), st = stage(age, size);
    $('[data-out-human]').textContent = age < 1 ? (Math.round(h * 10) / 10) : Math.round(h);
    $('[data-out-stage]').textContent = st;
    $('[data-out-dna]').textContent = age > 0 ? Math.max(0, Math.round(16 * Math.log(age) + 31)) : '—';
    $('[data-out-life]').textContent = LIFE[size];
    $('[data-out-senior]').textContent = SENIOR[size];
    var idx = { 'Puppy': 0, 'Adult': 1, 'Mature adult': 2, 'Senior': 3 }[st];
    root.querySelectorAll('[data-stage-bar] span').forEach(function (s, i) { if (i <= idx) s.setAttribute('data-on', ''); else s.removeAttribute('data-on'); });
    $('[data-stage-bar]').setAttribute('aria-label', 'Life stage: ' + st);
    var sub = $('[data-out-sub]');
    sub.textContent = st === 'Puppy' ? 'Puppy. Growing fast, learning faster.'
      : st === 'Adult' ? 'Adult. Prime of life.'
      : st === 'Mature adult' ? 'Mature adult. Think about joints, teeth and weight now, not later.'
      : 'Senior. Shorter walks, softer chews, more sniffing.';
    var flag = $('[data-flag]');
    if (age >= SENIOR[size]) { flag.hidden = false; flag.textContent = 'Senior dogs still need chewing and licking, just gentler versions: softer chews, a lick mat instead of a hard bone, and twice-yearly vet checks instead of once.'; }
    else if (age > 0 && age < 1) { flag.hidden = false; flag.textContent = 'Puppies mature at roughly 15 human years in their first twelve months, which is why the first year is the one that shapes everything.'; }
    else flag.hidden = true;
    // table
    var rows = [0.5, 1, 2, 3, 5, 7, 10, 12, 15], tb = root.querySelector('[data-table] tbody'), html = '';
    rows.forEach(function (y) {
      var now = Math.abs(y - age) < 0.75 && (y === rows.reduce(function (best, r) { return Math.abs(r - age) < Math.abs(best - age) ? r : best; }, rows[0]));
      html += '<tr' + (now ? ' data-now' : '') + '><td>' + (y === 0.5 ? '6 months' : y + ' years') + '</td><td><b>' + Math.round(human(y, size)) + '</b></td><td>' + stage(y, size) + '</td></tr>';
    });
    tb.innerHTML = html;
  }
  $('#age-y').addEventListener('input', function () { state.years = Math.max(0, parseInt(this.value, 10) || 0); compute(); });
  $('#age-m').addEventListener('input', function () { state.months = Math.min(11, Math.max(0, parseInt(this.value, 10) || 0)); compute(); });
  root.querySelectorAll('[data-group="size"] button').forEach(function (b) {
    b.addEventListener('click', function () {
      state.size = b.dataset.value;
      root.querySelectorAll('[data-group="size"] button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      compute();
    });
  });
  compute();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-tool-calories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-bsc]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var $ = function (s) { return root.querySelector(s); };
  var G_PER_IN = { thin: 2.6, standard: 5.1, thick: 10.0, jumbo: 17.0 };
  var KCAL_G = 3.0;
  var state = { unit: 'lb', weight: 45, factor: 1.6, len: 6, customLen: 8, tier: 'standard', grams: null };
  function press(group, value) {
    root.querySelectorAll('[data-group="' + group + '"] button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.value === value)); });
  }
  function round(n, d) { var f = Math.pow(10, d || 0); return Math.round(n * f) / f; }
  function compute() {
    var kg = state.unit === 'kg' ? state.weight : state.weight * 0.45359;
    if (!(kg > 0)) kg = 1;
    var mer = 70 * Math.pow(kg, 0.75) * state.factor, budget = mer * 0.10;
    var len = state.len === 'custom' ? state.customLen : state.len;
    var grams = state.grams && state.grams > 0 ? state.grams : len * G_PER_IN[state.tier];
    var stick = grams * KCAL_G, perWeek = budget * 7 / stick, share = stick / mer * 100;
    $('[data-out-stick]').textContent = Math.round(stick);
    $('[data-out-mer]').textContent = Math.round(mer);
    $('[data-out-budget]').textContent = Math.round(budget);
    $('[data-out-share]').textContent = round(share, 1);
    $('[data-out-week]').textContent = perWeek >= 10 ? Math.round(perWeek) : round(perWeek, 1);
    root.querySelector('.bsc__big span').textContent = (state.grams ? 'of these sticks' : len + '-inch ' + state.tier + ' sticks') + ' a week';
    var pct = Math.min(100, stick / budget * 100);
    $('[data-bar]').style.width = pct.toFixed(1) + '%';
    $('[data-bar-note]').textContent = (pct >= 100 ? 'one stick is ' + Math.round(stick / budget * 100) + '%' : Math.round(pct) + '%') + ' of a day’s treat budget';
    root.querySelector('[data-bar-label]').setAttribute('aria-label', 'One stick is ' + Math.round(stick / budget * 100) + ' percent of the daily treat budget');
    var sub = $('[data-out-sub]'), flag = $('[data-flag]');
    sub.textContent = perWeek < 1 ? 'Less than one. Break the stick, or buy a thinner one.'
      : perWeek < 3 ? 'Roughly ' + (perWeek < 2 ? 'one' : 'two') + ' a week is the ceiling, not a target.'
      : 'That’s the ceiling, not a target. Fewer is fine.';
    if (share >= 20) { flag.hidden = false; flag.innerHTML = 'One stick is <strong>' + round(share, 0) + '% of this dog’s whole day</strong>. For a dog this size, a shorter or thinner stick, or half of one saved for later, is the sane version.'; }
    else if (state.factor === 1) { flag.hidden = false; flag.textContent = 'On a vet-supervised diet, treats are usually squeezed below 10%. Check the chew allowance with your vet before using this number.'; }
    else flag.hidden = true;
  }
  $('#bsc-weight').addEventListener('input', function () { state.weight = parseFloat(this.value) || 0; compute(); });
  $('#bsc-len').addEventListener('input', function () { state.customLen = parseFloat(this.value) || 1; compute(); });
  $('#bsc-grams').addEventListener('input', function () { state.grams = parseFloat(this.value) || null; compute(); });
  $('#bsc-life').addEventListener('change', function () { state.factor = parseFloat(this.value); compute(); });
  root.querySelectorAll('.bsc__unit button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (state.unit === b.dataset.unit) return;
      state.weight = b.dataset.unit === 'kg' ? round(state.weight * 0.45359, 1) : round(state.weight / 0.45359, 1);
      state.unit = b.dataset.unit; $('#bsc-weight').value = state.weight;
      root.querySelectorAll('.bsc__unit button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      compute();
    });
  });
  root.querySelectorAll('[data-group="len"] button').forEach(function (b) {
    b.addEventListener('click', function () {
      state.len = b.dataset.value === 'custom' ? 'custom' : parseFloat(b.dataset.value);
      press('len', b.dataset.value); root.querySelector('[data-custom-len]').hidden = b.dataset.value !== 'custom'; compute();
    });
  });
  root.querySelectorAll('[data-group="tier"] button').forEach(function (b) {
    b.addEventListener('click', function () { state.tier = b.dataset.value; press('tier', b.dataset.value); compute(); });
  });
  compute();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-tool-choc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cwt="choc"]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var $ = function (s) { return root.querySelector(s); };
  var state = { unit: 'lb', weight: 30, mgPerOz: 58, amt: 1.5, aunit: 'oz' };
  function r1(n) { return Math.round(n * 10) / 10; }
  function compute() {
    var kg = state.unit === 'kg' ? state.weight : state.weight * 0.45359; if (!(kg > 0)) kg = 1;
    var oz = state.aunit === 'g' ? state.amt / 28.35 : state.amt;
    var total = oz * state.mgPerOz, dose = total / kg;
    var level = dose < 20 ? 'Low' : dose < 40 ? 'Mild' : dose < 60 ? 'Moderate' : dose < 100 ? 'Severe' : 'Life-threatening';
    $('[data-out-dose]').textContent = dose >= 10 ? Math.round(dose) : r1(dose);
    $('[data-out-total]').textContent = total >= 10 ? Math.round(total) : r1(total);
    $('[data-out-level]').textContent = level;
    var mildOz = 20 * kg / state.mgPerOz, sevOz = 60 * kg / state.mgPerOz, conv = state.aunit === 'g' ? 28.35 : 1;
    var fm = function (v) { v = v * conv; return v >= 100 ? Math.round(v) : v >= 10 ? Math.round(v) : r1(v); };
    $('[data-out-mild]').textContent = fm(mildOz); $('[data-out-severe]').textContent = fm(sevOz);
    $('[data-out-u]').textContent = state.aunit; $('[data-out-u2]').textContent = state.aunit;
    var pct = Math.min(100, dose / 80 * 100); $('[data-bar]').style.width = pct.toFixed(1) + '%';
    $('[data-bar]').style.background = dose < 20 ? '#035ca3' : dose < 40 ? '#e0a800' : '#eb4f45';
    $('[data-bar-label]').setAttribute('aria-label', 'Dose ' + Math.round(dose) + ' milligrams per kilogram, ' + level);
    var sub = $('[data-out-sub]'), flag = $('[data-flag]');
    flag.className = 'cwt__flag' + (dose >= 40 ? ' cwt__flag--red' : dose < 20 ? ' cwt__flag--green' : '');
    if (dose < 20) {
      sub.textContent = 'Below the level where symptoms usually start.';
      flag.innerHTML = state.mgPerOz <= 12 ? 'White chocolate and cocoa mixes carry very little theobromine; the sugar and fat are the bigger problem. Watch for an upset stomach.' : 'Usually no more than an upset stomach at this dose, but watch for vomiting, restlessness or a racing heart over the next 12 hours. Small dogs, puppies and seniors have less margin; a call to your vet is never wrong.';
    } else if (dose < 40) {
      sub.textContent = 'Mild poisoning is likely: vomiting, diarrhea, restlessness, thirst.';
      flag.innerHTML = '<strong>Call your vet or a poison helpline now.</strong> If it was eaten in the last 1–2 hours they may induce vomiting, which prevents most of what follows. Do not try to induce vomiting at home unless they tell you how.';
    } else if (dose < 60) {
      sub.textContent = 'Moderate poisoning: racing or irregular heartbeat, tremors, high blood pressure.';
      flag.innerHTML = '<strong>This is an emergency.</strong> Go to a vet now and bring the wrapper. Cardiac signs at this dose need monitoring, not waiting.';
    } else {
      sub.textContent = 'Severe poisoning: seizures, collapse. Potentially fatal.';
      flag.innerHTML = '<strong>Go to an emergency vet immediately.</strong> Call on the way: ' + '<a href="tel:+18557647661">(855) 764-7661</a>. Doses above 100 mg/kg can be fatal; minutes matter.';
    }
  }
  $('#choc-weight').addEventListener('input', function () { state.weight = parseFloat(this.value) || 0; compute(); });
  $('#choc-amt').addEventListener('input', function () { state.amt = parseFloat(this.value) || 0; compute(); });
  $('#choc-type').addEventListener('change', function () { state.mgPerOz = parseFloat(this.value); compute(); });
  root.querySelectorAll('[data-unit]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (state.unit === b.dataset.unit) return;
      state.weight = b.dataset.unit === 'kg' ? r1(state.weight * 0.45359) : r1(state.weight / 0.45359);
      state.unit = b.dataset.unit; $('#choc-weight').value = state.weight;
      root.querySelectorAll('[data-unit]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      compute();
    });
  });
  root.querySelectorAll('[data-aunit]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (state.aunit === b.dataset.aunit) return;
      state.amt = b.dataset.aunit === 'g' ? Math.round(state.amt * 28.35) : r1(state.amt / 28.35);
      state.aunit = b.dataset.aunit; $('#choc-amt').value = state.amt;
      root.querySelectorAll('[data-aunit]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      compute();
    });
  });
  root.querySelectorAll('[data-group="preset"] button').forEach(function (b) {
    b.addEventListener('click', function () {
      var oz = parseFloat(b.dataset.oz); state.amt = state.aunit === 'g' ? Math.round(oz * 28.35) : oz; $('#choc-amt').value = state.amt;
      root.querySelectorAll('[data-group="preset"] button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      compute();
    });
  });
  compute();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-tool-food"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cwt="food"]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var $ = function (s) { return root.querySelector(s); };
  var state = { unit: 'lb', weight: 45, factor: 1.6, kcal: 380, meals: 2 };
  function round(n, d) { var f = Math.pow(10, d || 0); return Math.round(n * f) / f; }
  function quarter(c) { return Math.round(c * 4) / 4; }
  function fmt(c) { var w = Math.floor(c), f = c - w, fr = { 0.25: '¼', 0.5: '½', 0.75: '¾' }[f] || ''; return (w || !fr ? w : '') + fr; }
  function compute() {
    var kg = state.unit === 'kg' ? state.weight : state.weight * 0.45359; if (!(kg > 0)) kg = 1;
    var rer = 70 * Math.pow(kg, 0.75), mer = rer * state.factor, kcalFood = mer * 0.9;
    var cups = kcalFood / (state.kcal || 380), perMeal = cups / state.meals, grams = cups * 100; // ~100 g per cup of kibble on average
    $('[data-out-cups]').textContent = fmt(quarter(cups)); $('[data-out-cupsw]').textContent = (quarter(cups) <= 1 ? 'cup' : 'cups') + ' a day';
    $('[data-out-kcal]').textContent = Math.round(mer);
    $('[data-out-meal]').textContent = fmt(quarter(perMeal));
    $('[data-out-grams]').textContent = Math.round(grams / 5) * 5;
    $('[data-out-treat]').textContent = Math.round(mer * 0.1);
    $('[data-out-sub]').textContent = 'About ' + fmt(quarter(perMeal)) + ' cup' + (quarter(perMeal) <= 1 ? '' : 's') + ' per meal, ' + state.meals + ' meal' + (state.meals > 1 ? 's' : '') + '. Treats stay inside the other 10%.';
    var flag = $('[data-flag]');
    if (state.factor === 3 && $('#food-life').selectedIndex === 0) { flag.hidden = false; flag.textContent = 'Young puppies do best on 3 to 4 small meals a day of a food labelled for growth. Re-run this every two weeks; they outgrow the number fast.'; }
    else if (state.factor === 1) { flag.hidden = false; flag.textContent = 'Weight-loss plans are calculated on target weight and usually need a vet to check the number. Treats are often capped well under 10% here.'; }
    else if (state.factor === 2.5) { flag.hidden = false; flag.textContent = 'Working dogs vary enormously. Start here, weigh them every two weeks, and adjust by 10% at a time.'; }
    else if (state.factor === 3) { flag.hidden = false; flag.textContent = 'Nursing mothers can need two to four times their normal calories depending on litter size. Feed free-choice unless your vet says otherwise.'; }
    else { flag.hidden = true; }
  }
  $('#food-weight').addEventListener('input', function () { state.weight = parseFloat(this.value) || 0; compute(); });
  $('#food-kcal').addEventListener('input', function () { state.kcal = parseFloat(this.value) || 380; compute(); });
  $('#food-life').addEventListener('change', function () { state.factor = parseFloat(this.value); compute(); });
  root.querySelectorAll('.cwt__unit button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (state.unit === b.dataset.unit) return;
      state.weight = b.dataset.unit === 'kg' ? round(state.weight * 0.45359, 1) : round(state.weight / 0.45359, 1);
      state.unit = b.dataset.unit; $('#food-weight').value = state.weight;
      root.querySelectorAll('.cwt__unit button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      compute();
    });
  });
  root.querySelectorAll('[data-group="meals"] button').forEach(function (b) {
    b.addEventListener('click', function () {
      state.meals = parseInt(b.dataset.value, 10);
      root.querySelectorAll('[data-group="meals"] button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      compute();
    });
  });
  compute();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-tool-foods"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-lmf]');
  if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  var data = JSON.parse(document.querySelector('[data-lmf-data]').textContent);
  var LABEL = { base: 'Good base', limit: 'Small amounts', never: 'Never' };
  var list = root.querySelector('[data-lmf-list]'), empty = root.querySelector('[data-lmf-empty]'), count = root.querySelector('[data-lmf-count]');
  var q = root.querySelector('#lmf-q'), filter = 'all';
  function norm(s) { return s.toLowerCase().replace(/[^a-z0-9 ]/g, ' '); }
  function render() {
    var needle = norm(q.value.trim()), shown = 0; list.innerHTML = '';
    data.forEach(function (d) {
      if (filter !== 'all' && d.s !== filter) return;
      if (needle && norm(d.n + ' ' + d.t).indexOf(needle) === -1) return;
      var li = document.createElement('li'); li.className = 'lmf__item lmf__item--' + d.s;
      li.innerHTML = '<b></b><small></small><p></p>';
      li.querySelector('b').textContent = d.n; li.querySelector('small').textContent = LABEL[d.s]; li.querySelector('p').textContent = d.t;
      list.appendChild(li); shown++;
    });
    empty.hidden = shown > 0;
    count.textContent = needle || filter !== 'all' ? shown + ' of ' + data.length + ' foods' : data.length + ' foods. Start typing, or tap a verdict.';
  }
  q.addEventListener('input', render);
  root.querySelectorAll('[data-filter]').forEach(function (b) {
    b.addEventListener('click', function () {
      filter = b.dataset.filter;
      root.querySelectorAll('[data-filter]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      render();
    });
  });
  var nl = root.querySelector('[data-lmf-neverlist]');
  data.filter(function (d) { return d.s === 'never'; }).forEach(function (d) { var li = document.createElement('li'); li.textContent = d.n; nl.appendChild(li); });
  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-tool-names"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cwt="names"]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var $ = function (s) { return root.querySelector(s); };
  var DATA = JSON.parse(document.querySelector('[data-cwn-data]').textContent);
  var state = { gender: 'u', tags: ['classic'], letter: '', short: [], seed: 1 };
  try { state.short = JSON.parse(localStorage.getItem('cw-names-short') || '[]'); } catch (e) {}
  var sel = $('#names-letter'); 'ABCDEFGHIJKLMNOPRSTVWZ'.split('').forEach(function (l) { var o = document.createElement('option'); o.value = l; o.textContent = l; sel.appendChild(o); });
  function rnd() { state.seed = (state.seed * 9301 + 49297) % 233280; return state.seed / 233280; }
  function matches() {
    return DATA.filter(function (n) {
      if (state.gender !== 'u' && n[1] !== 'u' && n[1] !== state.gender) return false;
      if (state.letter && n[0][0].toUpperCase() !== state.letter) return false;
      if (state.tags.length && !state.tags.some(function (t) { return n[2].indexOf(t) >= 0; })) return false;
      return true;
    });
  }
  var HEART = '<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>';
  function render() {
    var m = matches(), pick = m.slice().sort(function () { return rnd() - 0.5; }).slice(0, 12);
    $('[data-count]').textContent = m.length ? Math.min(12, m.length) + ' of ' + m.length + ' matches' + (m.length > 12 ? '. Shuffle for more.' : '.') : 'No matches';
    $('[data-flag]').hidden = m.length > 0;
    $('[data-results]').innerHTML = pick.map(function (n) {
      var on = state.short.indexOf(n[0]) >= 0;
      return '<li><b>' + n[0] + (n[1] !== 'u' ? '<i>' + (n[1] === 'f' ? 'girl' : 'boy') + '</i>' : '') + '</b><small>' + n[3] + '</small><button type="button" class="cwn__heart" data-name="' + n[0] + '" aria-pressed="' + on + '" aria-label="Save ' + n[0] + '">' + HEART + '</button></li>';
    }).join('');
  }
  function renderShort() {
    $('[data-shortlist]').innerHTML = state.short.map(function (n) { return '<li>' + n + '<button type="button" data-rm="' + n + '" aria-label="Remove ' + n + '">&times;</button></li>'; }).join('');
    $('[data-short-empty]').hidden = state.short.length > 0; $('[data-short-actions]').hidden = state.short.length === 0;
    try { localStorage.setItem('cw-names-short', JSON.stringify(state.short)); } catch (e) {}
  }
  root.addEventListener('click', function (e) {
    var h = e.target.closest('.cwn__heart'); if (h) { var n = h.dataset.name, i = state.short.indexOf(n); if (i >= 0) state.short.splice(i, 1); else state.short.push(n); h.setAttribute('aria-pressed', String(i < 0)); renderShort(); return; }
    var rm = e.target.closest('[data-rm]'); if (rm) { state.short = state.short.filter(function (x) { return x !== rm.dataset.rm; }); renderShort(); root.querySelectorAll('.cwn__heart').forEach(function (b) { b.setAttribute('aria-pressed', String(state.short.indexOf(b.dataset.name) >= 0)); }); return; }
    if (e.target.closest('[data-clear]')) { state.short = []; renderShort(); root.querySelectorAll('.cwn__heart').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); }); return; }
    if (e.target.closest('[data-copy]')) { var btn = e.target.closest('[data-copy]'), txt = state.short.join(', '); (navigator.clipboard ? navigator.clipboard.writeText(txt) : Promise.reject()).then(function () { btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = 'Copy shortlist'; }, 1500); }, function () { window.prompt('Your shortlist', txt); }); return; }
    if (e.target.closest('[data-shuffle]')) { state.seed = Math.floor(Math.random() * 233279) + 1; render(); return; }
    var g = e.target.closest('[data-group="gender"] button'); if (g) { state.gender = g.dataset.value; root.querySelectorAll('[data-group="gender"] button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === g)); }); render(); return; }
    var t = e.target.closest('[data-group="tags"] button'); if (t) { var v = t.dataset.value, j = state.tags.indexOf(v); if (j >= 0) state.tags.splice(j, 1); else state.tags.push(v); t.setAttribute('aria-pressed', String(j < 0)); render(); return; }
  });
  sel.addEventListener('change', function () { state.letter = this.value; render(); });
  state.seed = Math.floor(Math.random() * 233279) + 1;
  render(); renderShort();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-tool-preg"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cwt="preg"]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var $ = function (s) { return root.querySelector(s); };
  var OFFSET = { mating: 63, ovulation: 63, lh: 65 }, SPREAD = { mating: 5, ovulation: 2, lh: 2 };
  var state = { date: null, basis: 'mating' };
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function add(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function fmt(d, y) { return MONTHS[d.getMonth()] + ' ' + d.getDate() + (y ? ', ' + d.getFullYear() : ''); }
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  var WEEKS = [
    ['1', 'Fertilisation. Nothing visible; keep exercise and food exactly as normal.'],
    ['2', 'Embryos travel to the uterus. No diet change yet.'],
    ['3', 'Implantation around day 18–21. Some dogs go off food or get clingy for a few days.'],
    ['4', 'Vet can confirm by ultrasound (day 25–28) or palpation (day 28–35). Nipples pink and enlarge.'],
    ['5', 'Belly starts to show. Switch gradually to a puppy or growth food from day 35–40.'],
    ['6', 'Appetite rises; feed smaller, more frequent meals. Set up the whelping box so she can get used to it.'],
    ['7', 'X-ray from day 45 shows skeletons, so the vet can count puppies. Clipping belly hair helps nursing.'],
    ['8', 'Milk may appear. Nesting and restlessness begin. Start taking her temperature twice a day.'],
    ['9', 'Temperature drops below 99°F (37.2°C) about 12–24 hours before labour. Whelping, days 57–68.']
  ];
  function compute() {
    if (!state.date) return;
    var start = state.date, n = OFFSET[state.basis], s = SPREAD[state.basis];
    var due = add(start, n), lo = add(start, n - s), hi = add(start, n + s);
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var day = Math.round((today - start) / 86400000);
    $('[data-out-due]').textContent = fmt(due, true);
    $('[data-out-window]').textContent = 'Most likely between ' + fmt(lo) + ' and ' + fmt(hi) + '. Puppies born before day 57 or after day 70 need a vet involved.';
    $('[data-out-us]').textContent = fmt(add(start, 25)); $('[data-out-xr]').textContent = fmt(add(start, 45));
    $('[data-out-food]').textContent = fmt(add(start, 35)); $('[data-out-box]').textContent = fmt(add(start, 49));
    var pct = Math.max(0, Math.min(100, day / n * 100)); $('[data-bar]').style.width = pct.toFixed(1) + '%';
    $('[data-out-pct]').textContent = day < 0 ? 'Not yet' : day > n + s ? 'Past due' : 'Day ' + day + ' of ' + n;
    $('[data-out-today]').textContent = day < 0 ? 'That date is in the future, so this is a plan, not a countdown.'
      : day > n + s ? 'Day ' + day + '. If she hasn’t whelped, call your vet today.'
      : 'Day ' + day + ' of ' + n + ', week ' + Math.min(9, Math.floor(day / 7) + 1) + ' of 9. ' + (n - day) + ' days to go.';
    var tb = root.querySelector('[data-table] tbody'), html = '';
    WEEKS.forEach(function (w, i) {
      var a = add(start, i * 7), b = add(start, i * 7 + 6), now = day >= i * 7 && day <= i * 7 + 6;
      html += '<tr' + (now ? ' data-now' : '') + '><td><b>' + w[0] + '</b></td><td>' + fmt(a) + '–' + fmt(b) + '</td><td>' + w[1] + '</td></tr>';
    });
    tb.innerHTML = html;
    var flag = $('[data-flag]');
    if (day >= 56 && day <= n + s) { flag.hidden = false; flag.innerHTML = '<strong>Whelping window.</strong> Rectal temperature twice daily; a drop under 99°F means puppies within a day. Call the vet if she strains hard for 30 minutes without a puppy, goes more than 2 hours between puppies, or there is green discharge before the first one.'; }
    else if (state.basis === 'mating') { flag.hidden = false; flag.textContent = 'Counting from a mating date gives a 10-day window. If your vet ran progesterone tests, use the ovulation date instead; it narrows the window to a few days.'; }
    else flag.hidden = true;
  }
  var input = $('#preg-date');
  input.addEventListener('change', function () { var v = this.value; if (!v) return; var p = v.split('-'); state.date = new Date(+p[0], +p[1] - 1, +p[2]); compute(); });
  root.querySelectorAll('[data-group="basis"] button').forEach(function (b) {
    b.addEventListener('click', function () { state.basis = b.dataset.value; root.querySelectorAll('[data-group="basis"] button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); compute(); });
  });
  // sensible default: 20 days ago, so the page shows something useful immediately
  var d = new Date(); d.setHours(0, 0, 0, 0); d.setDate(d.getDate() - 20); state.date = d; input.value = iso(d); compute();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-tool-puppy"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cwt="puppy"]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var $ = function (s) { return root.querySelector(s); };
  // Percent of adult weight reached at a given age in weeks, by adult size class (smoothed from breed-size growth curves).
  var CURVE = {
    toy:    [[4,12],[8,30],[12,48],[16,63],[20,75],[26,86],[32,93],[40,98],[48,100]],
    small:  [[4,10],[8,27],[12,43],[16,57],[20,69],[26,81],[32,90],[40,96],[52,100]],
    medium: [[4,8],[8,22],[12,36],[16,49],[20,60],[26,72],[32,82],[40,91],[52,98],[60,100]],
    large:  [[4,6],[8,18],[12,30],[16,42],[20,52],[26,63],[32,73],[40,84],[52,94],[65,100]],
    giant:  [[4,5],[8,14],[12,24],[16,34],[20,43],[26,53],[32,63],[40,74],[52,86],[65,95],[78,100]]
  };
  var DONE = { toy: 10, small: 12, medium: 14, large: 15, giant: 18 };
  var state = { unit: 'lb', weight: 12, age: 12, size: 'medium' };
  function pct(size, w) {
    var c = CURVE[size]; if (w <= c[0][0]) return c[0][1]; if (w >= c[c.length - 1][0]) return 100;
    for (var i = 1; i < c.length; i++) if (w <= c[i][0]) { var a = c[i - 1], b = c[i]; return a[1] + (b[1] - a[1]) * (w - a[0]) / (b[0] - a[0]); }
    return 100;
  }
  function r1(n) { return Math.round(n * 10) / 10; }
  function fmtW(n) { return n >= 20 ? Math.round(n) : r1(n); }
  function compute() {
    var p = pct(state.size, state.age) / 100, adult = state.weight / p, lo = adult * 0.9, hi = adult * 1.1;
    var u = state.unit;
    $('[data-out-adult]').textContent = fmtW(adult); $('[data-out-unit]').textContent = u;
    $('[data-out-sub]').textContent = 'Likely range ' + fmtW(lo) + '–' + fmtW(hi) + ' ' + u + '. Fully grown at about ' + DONE[state.size] + ' months.';
    $('[data-out-pct]').textContent = Math.round(p * 100);
    $('[data-out-done]').textContent = DONE[state.size];
    var adultLb = u === 'kg' ? adult / 0.45359 : adult;
    $('[data-out-holder]').textContent = adultLb < 20 ? 'Small' : adultLb <= 70 ? 'Standard' : 'Extra-Large';
    $('[data-out-phase]').textContent = state.age < 20 ? 'Fast' : p < 0.9 ? 'Steady' : 'Filling out';
    var rows = [8, 12, 16, 20, 26, 32, 40, 52], tb = root.querySelector('[data-table] tbody'), html = '';
    if (state.size === 'giant' || state.size === 'large') rows.push(65);
    rows.forEach(function (w) {
      var pp = pct(state.size, w) / 100, now = Math.abs(w - state.age) <= 2;
      html += '<tr' + (now ? ' data-now' : '') + '><td>' + (w % 4 === 0 && w / 4 <= 12 ? (w / 4) + ' months' : w + ' weeks') + '</td><td><b>' + fmtW(adult * pp) + ' ' + u + '</b></td><td>' + Math.round(pp * 100) + '%</td></tr>';
    });
    tb.innerHTML = html;
    var flag = $('[data-flag]');
    if (state.age < 8) { flag.hidden = false; flag.textContent = 'Under 8 weeks the curve is steep and litters vary a lot. Weigh again at 8 and 12 weeks for a number you can trust.'; }
    else if (state.age > 40) { flag.hidden = false; flag.textContent = 'Past 40 weeks most of the growing is done; what’s left is filling out. Your scale is now more accurate than any formula.'; }
    else if ((state.size === 'toy' && adultLb > 20) || (state.size === 'giant' && adultLb < 60) || (state.size === 'small' && adultLb > 40) || (state.size === 'large' && adultLb < 30)) { flag.hidden = false; flag.textContent = 'That estimate doesn’t match the size class you picked, which usually means the class is off. Try the next size up or down and see which gives a sensible adult weight.'; }
    else flag.hidden = true;
  }
  $('#pup-weight').addEventListener('input', function () { state.weight = parseFloat(this.value) || 0.2; compute(); });
  $('#pup-age').addEventListener('input', function () { state.age = Math.min(78, Math.max(4, parseFloat(this.value) || 4)); compute(); });
  root.querySelectorAll('.cwt__unit button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (state.unit === b.dataset.unit) return;
      state.weight = b.dataset.unit === 'kg' ? r1(state.weight * 0.45359) : r1(state.weight / 0.45359);
      state.unit = b.dataset.unit; $('#pup-weight').value = state.weight;
      root.querySelectorAll('.cwt__unit button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      compute();
    });
  });
  root.querySelectorAll('[data-group="size"] button').forEach(function (b) {
    b.addEventListener('click', function () {
      state.size = b.dataset.value;
      root.querySelectorAll('[data-group="size"] button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      compute();
    });
  });
  compute();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-tool-recipes"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-lmr]'); if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  var cards = root.querySelectorAll('.lmr__card'), count = root.querySelector('[data-lmr-count]');
  function apply(tag) {
    var n = 0;
    cards.forEach(function (c) { var on = tag === 'all' || (' ' + c.dataset.tags + ' ').indexOf(' ' + tag + ' ') > -1; c.hidden = !on; if (on) n++; });
    count.textContent = n + ' of ' + cards.length + ' recipes';
  }
  root.querySelectorAll('[data-tag]').forEach(function (b) {
    b.addEventListener('click', function () { root.querySelectorAll('[data-tag]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); apply(b.dataset.tag); });
  });
  apply('all');
})();

  } catch(e) { console.error(e); }
})();
})();
